module.exports = __webpack_public_path__ + "static/media/bulk_password.102bac0c.csv";